/**
 * Bullet list extension that preserves a `class` attribute on <ul> (e.g. for AI diff highlights).
 * Uses a custom NodeView so the class is applied to the rendered element.
 */
import BulletList from "@tiptap/extension-bullet-list";
import { mergeAttributes } from "@tiptap/core";

export const BulletListWithClass = BulletList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute("class") || null,
        renderHTML: (attributes) =>
          attributes.class ? { class: attributes.class } : {},
      },
    };
  },
  parseHTML() {
    return [
      {
        tag: "ul",
        getAttrs: (dom) => ({
          class: dom.getAttribute?.("class") || null,
        }),
      },
    ];
  },
  renderHTML({ node, HTMLAttributes }) {
    const classValue = node.attrs.class;
    return [
      "ul",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        ...(classValue ? { class: classValue } : {}),
      }),
      0,
    ];
  },
  addNodeView() {
    return ({ node, HTMLAttributes }) => {
      const ul = document.createElement("ul");
      const cls = node.attrs.class;
      if (cls) ul.className = cls;
      mergeAttributes(ul, this.options.HTMLAttributes, HTMLAttributes);
      return {
        dom: ul,
        contentDOM: ul,
        update(updatedNode) {
          if (updatedNode.type !== node.type) return false;
          ul.className = updatedNode.attrs.class || "";
          return true;
        },
      };
    };
  },
});
